import { create, w } from '@dojo/framework/core/vdom';
import { ChartBase } from '@holmescorp/charts';
const factory = create({}).properties();
export const ScatterChart = factory(({ properties }) => {
    const { ariaLabel = 'scatter chart', size, data, drawComplete, legend, options, plugins, pluginCode, title, alternateText } = properties();
    const type = 'scatter';
    return w(ChartBase, {
        ariaLabel,
        alternateText,
        size,
        data,
        drawComplete,
        legend,
        options,
        plugins,
        pluginCode,
        title,
        type
    });
});
